import React from 'react';

const FloatingButtons = () => {
  return null; // removed per request
};

export default FloatingButtons;
